import React from 'react'
import MetaTags from '../../seo/MetaTags'

export default function HomeMetaManager() {
  return <MetaTags alternateLinkPath="/" />
}
